/* eslint-disable */
import React from "react";
import Icon from "../Icon";
const Close = props => {
  const {
    color,
    size,
    width,
    height,
    customColor,
    className,
    dataTest,
    ariaHidden,
    ariaLabel,
    reverseOnRtl
  } = props;
  return React.createElement(Icon, {
    viewBox: "0 0 24 24",
    size: size,
    width: width,
    height: height,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#clip0)",
    clipRule: "evenodd"
  }, React.createElement("path", {
    d: "M22.694 20.803L2.924 1.79c-.423-.407-.931-.34-1.27.17-.338.511-.281 1.123.142 1.53l19.77 19.014c.424.407.932.339 1.27-.171.338-.51.282-1.122-.142-1.53z"
  }), React.createElement("path", {
    d: "M21.4 1.576L1.936 21.04c-.418.417-.465 1.03-.118 1.532.346.502.855.559 1.272.142L22.555 3.249c.417-.417.464-1.03.117-1.532-.346-.502-.855-.558-1.272-.141z"
  })));
};
export default Close;